import { DocumentConnection } from '../../common/model/document-connection-base';
import { LocalDate } from '../../core/model/local-date';
import { LeaseAgreementDocumentType, LeaseAgreementDocumentTypeToString } from './const/documentEnums';
import { ESignatory } from './esignatory';

export class LeaseAgreementDocument extends DocumentConnection<LeaseAgreementDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return LeaseAgreementDocumentTypeToString(this.connectionType);
  }

  signatories: ESignatory[];
  leaseAgreementId: string;
  eSignatureStatusText: string;
  sendForEsign: boolean;
  errandDescription: string;

  private _expirationDate: LocalDate;
  get expirationDate(): LocalDate {
    return this._expirationDate;
  }
  set expirationDate(value: LocalDate) {
    this._expirationDate = LocalDate.fromDate(value);
  }

  toJSON() {
    const result = super.toJSON();
    result['leaseAgreementId'] = this.leaseAgreementId;
    result['signatories'] = this.signatories;
    result['errandDescription'] = this.errandDescription;
    result['sendForEsign'] = this.sendForEsign;
    result['expirationDate'] = this.expirationDate;
    return result;
  }
}
